import React, { Component } from 'react';
import { getTables, createTable, updateTable } from '../utils/reservationsApi';

// Administración de las mesas del salón (alta / edición / baja). Antes las mesas sólo se podían
// crear por migración; ahora se manejan desde acá. La baja es LÓGICA (`active=0`): la mesa deja
// de ofrecerse para sentar/reservar pero las reservas históricas siguen mostrando su nombre.
class TablesSettingsComponent extends Component {
  constructor() {
    super();
    this.state = {
      tables: [],
      loaded: false,
      busy: false,
      message: null,
      form: { label: '', capacity: 4, isVip: false },
      editing: null, // { id, label, capacity, isVip }
    };
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    try {
      const data = await getTables(true); // incluye las dadas de baja
      this.setState({ tables: (data && data.tables) || [], loaded: true });
    } catch (e) {
      this.setState({ loaded: true, message: { type: 'danger', text: e.message } });
    }
  };

  setForm = (patch) => this.setState({ form: { ...this.state.form, ...patch } });
  setEditing = (patch) => this.setState({ editing: { ...this.state.editing, ...patch } });

  add = async () => {
    if (this.state.busy) return;
    const { label, capacity, isVip } = this.state.form;
    this.setState({ busy: true, message: null });
    try {
      await createTable({ label, capacity: Number(capacity), isVip });
      this.setState({ busy: false, form: { label: '', capacity: 4, isVip: false }, message: { type: 'success', text: 'Mesa creada.' } });
      this.load();
    } catch (e) {
      this.setState({ busy: false, message: { type: 'danger', text: e.message } });
    }
  };

  saveEdit = async () => {
    if (this.state.busy || !this.state.editing) return;
    const { id, label, capacity, isVip } = this.state.editing;
    this.setState({ busy: true, message: null });
    try {
      await updateTable(id, { label, capacity: Number(capacity), isVip });
      this.setState({ busy: false, editing: null, message: { type: 'success', text: 'Mesa actualizada.' } });
      this.load();
    } catch (e) {
      this.setState({ busy: false, message: { type: 'danger', text: e.message } });
    }
  };

  toggleActive = async (table) => {
    if (this.state.busy) return;
    const activating = Number(table.active) === 0;
    if (!activating && !window.confirm(`¿Dar de baja "${table.label}"? Deja de ofrecerse para sentar, pero no se borra el historial.`)) return;
    this.setState({ busy: true, message: null });
    try {
      await updateTable(table.id, { active: activating });
      this.setState({ busy: false, message: { type: 'success', text: activating ? 'Mesa reactivada.' : 'Mesa dada de baja.' } });
      this.load();
    } catch (e) {
      this.setState({ busy: false, message: { type: 'danger', text: e.message } });
    }
  };

  renderRow(t) {
    const editing = this.state.editing && this.state.editing.id === t.id;
    const inactive = Number(t.active) === 0;
    if (editing) {
      const e = this.state.editing;
      return (
        <tr key={t.id}>
          <td><input type="text" className="form-control form-control-sm" value={e.label}
            onChange={(ev) => this.setEditing({ label: ev.target.value })} /></td>
          <td><input type="number" className="form-control form-control-sm" style={{ width: 80 }} value={e.capacity}
            onChange={(ev) => this.setEditing({ capacity: ev.target.value })} /></td>
          <td className="text-center"><input type="checkbox" checked={!!e.isVip}
            onChange={(ev) => this.setEditing({ isVip: ev.target.checked })} /></td>
          <td>
            <button type="button" className="btn btn-sm btn-primary mr-1" disabled={this.state.busy} onClick={this.saveEdit}>Guardar</button>
            <button type="button" className="btn btn-sm btn-white" onClick={() => this.setState({ editing: null })}>Cancelar</button>
          </td>
        </tr>
      );
    }
    return (
      <tr key={t.id} style={inactive ? { opacity: 0.55 } : null}>
        <td className="align-middle">
          {t.label}{inactive && <span className="badge badge-secondary ml-2">De baja</span>}
        </td>
        <td className="align-middle">{t.capacity}</td>
        <td className="align-middle text-center">{Number(t.is_vip) === 1 ? '★' : ''}</td>
        <td>
          <button type="button" className="btn btn-sm btn-white mr-1"
            onClick={() => this.setState({ editing: { id: t.id, label: t.label, capacity: t.capacity, isVip: Number(t.is_vip) === 1 } })}>
            Editar
          </button>
          <button type="button" className="btn btn-sm btn-white" disabled={this.state.busy} onClick={() => this.toggleActive(t)}>
            {inactive ? 'Reactivar' : 'Dar de baja'}
          </button>
        </td>
      </tr>
    );
  }

  render() {
    const { tables, loaded, message, form } = this.state;
    const activas = tables.filter((t) => Number(t.active) === 1).length;
    return (
      <div className="card card-small mb-4">
        <div className="card-header border-bottom d-flex justify-content-between align-items-center">
          <h6 className="m-0">Mesas del salón</h6>
          <small className="text-muted">{activas} activa(s) de {tables.length}</small>
        </div>
        <div className="card-body">
          {message && <div className={`alert alert-${message.type}`}>{message.text}</div>}

          {!loaded ? (
            <p className="text-muted">Cargando…</p>
          ) : (
            <table className="table table-sm mb-3" style={{ maxWidth: 560 }}>
              <thead>
                <tr>
                  <th className="border-0"><small>Mesa</small></th>
                  <th className="border-0"><small>Capacidad</small></th>
                  <th className="border-0 text-center"><small>VIP</small></th>
                  <th className="border-0"></th>
                </tr>
              </thead>
              <tbody>
                {tables.length === 0
                  ? <tr><td colSpan="4" className="text-muted">Todavía no hay mesas cargadas.</td></tr>
                  : tables.map((t) => this.renderRow(t))}
              </tbody>
            </table>
          )}

          <div className="form-row align-items-end" style={{ maxWidth: 560 }}>
            <div className="form-group col-5 mb-2">
              <label><small>Nueva mesa</small></label>
              <input type="text" className="form-control form-control-sm" placeholder="Ej: Mesa 4-D"
                value={form.label} onChange={(e) => this.setForm({ label: e.target.value })} />
            </div>
            <div className="form-group col-3 mb-2">
              <label><small>Capacidad</small></label>
              <input type="number" className="form-control form-control-sm" min="1"
                value={form.capacity} onChange={(e) => this.setForm({ capacity: e.target.value })} />
            </div>
            <div className="form-group col-2 mb-2">
              <label className="d-block"><small>VIP</small></label>
              <input type="checkbox" checked={form.isVip} onChange={(e) => this.setForm({ isVip: e.target.checked })} />
            </div>
            <div className="form-group col-2 mb-2">
              <button type="button" className="btn btn-primary btn-sm" disabled={this.state.busy || !form.label.trim()} onClick={this.add}>
                Agregar
              </button>
            </div>
          </div>
          <p className="text-muted mb-0" style={{ fontSize: 12 }}>
            Dar de baja no borra la mesa: deja de ofrecerse para sentar/reservar y el historial se conserva.
            No se puede dar de baja una mesa con reservas en curso.
          </p>
        </div>
      </div>
    );
  }
}

export default TablesSettingsComponent;
